'use client'

import * as React from 'react'
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@/global/Header/navigation-menu'
import { Header } from '@/payload-types'
import { getCMSLinkHrefAndTabProps } from '@/utilities/getCMSLinkHref'
import { NavButton, NavLink } from './NavLink'
import { usePathname } from 'next/navigation'
import { isSectionActive, isLinkActive } from './utils'
import { ListItem } from './ListItem'

export function DesktopNav({ data }: { data: Header }) {
  const pathname = usePathname()
  return (
    <NavigationMenu className="w-full h-full @container">
      <NavigationMenuList className="w-full">
        {data.sections?.map((section) => (
          <NavigationMenuItem key={section.title} className="hidden @xl:block">
            <NavigationMenuTrigger>
              <NavButton active={isSectionActive(pathname, section)}>{section.title}</NavButton>
            </NavigationMenuTrigger>
            <NavigationMenuContent>
              <div className="flex flex-col gap-3 w-[300px]">
                {section.items?.map((item) => (
                  <ListItem
                    key={item.id}
                    icon={item.icon ?? ''}
                    title={item.link.label}
                    {...getCMSLinkHrefAndTabProps(item.link)}
                  >
                    {item.description}
                  </ListItem>
                ))}
              </div>
            </NavigationMenuContent>
          </NavigationMenuItem>
        ))}
        {data.links?.map((link) => {
          const props = getCMSLinkHrefAndTabProps(link.link)
          return (
            <NavigationMenuItem key={link.id} className="hidden @xl:block">
              <NavigationMenuLink asChild>
                <NavLink {...props} active={isLinkActive(pathname, link)} />
              </NavigationMenuLink>
            </NavigationMenuItem>
          )
        })}
      </NavigationMenuList>
    </NavigationMenu>
  )
}
